import {
  createFileRoute,
  useParams,
  useRouter,
  useSearch,
} from "@tanstack/react-router"
import {
  CorrespondenceThreadRoute,
  CorrespondenceThreadSearchSchema,
} from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useOrganizationUserQuery } from "@/api/queries/organizationUser/useOrganizationUserQuery"
import { correspondenceQueryKeys } from "toptaal-shared"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"

export const Route = createFileRoute("/correspondentie/$threadId")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "correspondence"),
  validateSearch: CorrespondenceThreadSearchSchema,
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useOrganizationUserQuery()
  const { threadId: threadIdParam } = useParams({
    from: "/correspondentie/$threadId",
  })
  const search = useSearch({
    from: "/correspondentie/$threadId",
  })

  const entityType = search.entityType
  const entityId = search.entityId || 0
  const threadId = Number(threadIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: "/correspondentie",
    })
  }

  return (
    <ScreenWrapper className="!px-0">
      <CorrespondenceThreadRoute
        threadId={threadId}
        entityType={entityType}
        entityId={entityId}
        user={user}
        correspondenceQueryKeys={correspondenceQueryKeys}
        onNavigateBack={handleNavigateBack}
        showEditButton={false}
      />
    </ScreenWrapper>
  )
}
